/**
 * Shared config for the 7 chess tournament types.
 * Used on landing (ChessTournamentTypes), create room modal, and room cards.
 * Only arena is active for creation/landing; others commented out (can be re-enabled later).
 */
export interface ChessTournamentTypeConfig {
  id: string
  keyPrefix: string
  icon: string
  color: string
  gradient: string
}

export const CHESS_TOURNAMENT_TYPE_CONFIGS: ChessTournamentTypeConfig[] = [
  { id: 'arena', keyPrefix: 'arena', icon: '📈', color: 'from-teal-500/20 to-cyan-500/20', gradient: 'from-teal-400 to-cyan-500' },
  // Deactivated for room creation and landing (only chess arena active):
  // { id: 'round-robin', keyPrefix: 'roundRobin', icon: '🔄', color: 'from-purple-500/20 to-pink-500/20', gradient: 'from-purple-400 to-pink-500' },
  // { id: 'swiss', keyPrefix: 'swiss', icon: '⚖️', color: 'from-blue-500/20 to-cyan-500/20', gradient: 'from-blue-400 to-cyan-500' },
  // { id: 'champions-league', keyPrefix: 'champions', icon: '🏆', color: 'from-amber-500/20 to-yellow-500/20', gradient: 'from-amber-400 to-yellow-500' },
  // { id: 'handicap', keyPrefix: 'handicap', icon: '🎯', color: 'from-green-500/20 to-emerald-500/20', gradient: 'from-green-400 to-emerald-500' },
  // { id: 'team', keyPrefix: 'team', icon: '👥', color: 'from-indigo-500/20 to-blue-500/20', gradient: 'from-indigo-400 to-blue-500' },
  // { id: 'survival', keyPrefix: 'survival', icon: '⚔️', color: 'from-red-500/20 to-orange-500/20', gradient: 'from-red-400 to-orange-500' },
]

export function getChessTournamentConfig(tournamentTypeId: string): ChessTournamentTypeConfig | undefined {
  return CHESS_TOURNAMENT_TYPE_CONFIGS.find((c) => c.id === tournamentTypeId)
}
